import {
  EMPTY_HOV_SKILL_EFFECT_MODIFIERS,
  type HovSkillEffectModifier,
} from "./hovSkillModifiers";

export type HovSkillEffectModifierProvider =
  () => readonly HovSkillEffectModifier[];

export const EMPTY_HOV_SKILL_EFFECT_MODIFIER_PROVIDER: HovSkillEffectModifierProvider =
  () => EMPTY_HOV_SKILL_EFFECT_MODIFIERS;

export function collectHovSkillEffectModifiers(
  providers: readonly HovSkillEffectModifierProvider[],
): readonly HovSkillEffectModifier[] {
  if (providers.length === 0) {
    return EMPTY_HOV_SKILL_EFFECT_MODIFIERS;
  }

  const collected: HovSkillEffectModifier[] = [];
  for (const provider of providers) {
    for (const modifier of provider()) {
      collected.push(modifier);
    }
  }

  if (collected.length === 0) {
    return EMPTY_HOV_SKILL_EFFECT_MODIFIERS;
  }

  return collected;
}
